import React from 'react';
import Img from 'react-cool-img';
import { useTranslation } from 'react-i18next';

import { DateHelper, DEFAULT_DATE_FORMAT } from '@utils/DateHelper';

import { Article } from '@common/domain/models/Article';

import { PlaceholderImage } from '@assets/images';
import { Play } from '@assets/index';
import { translate } from '@translations/Translater';

import { Card } from '@components/Card';
import Text, { FontFamilyVariant, TextType } from "@components/Text";

import { libraryMessages } from '@containers/Library/messages';

import { ContentType, getContentDuration } from '@presentation/Content/config';

import './styles.less';

interface IProps {
    content: Article;
    onCardClick?: () => void
}

const ContentCard = (props: IProps) => {
    const { content, onCardClick } = props;
    const { t } = useTranslation();

    if (Object.keys(content)?.length === 0) {
        return null;
    }

    const isVideo = !!content?.getVideoUrl();
    const image = content?.getCoverImageUrl() || content?.getOgData()?.image;
    const title = content?.getTitle();
    const uploadedDate = content?.getCreatedAt();
    const tags = [...content?.getTags()?.public?.category || [] ,
     ...content?.getTags()?.public?.topic || [], ...content?.getTags()?.public?.keywords || []];

    return (
        <Card className="video_card" onClick={onCardClick}>
            <div className={`cover_image_container`}>
                {isVideo && <img className="play_icon" src={Play} />}
                <Img
                    className={`cover_image`}
                    src={image}
                    onError={''}
                    retry={{ count: 0 }}
                    debounce={0}
                    placeholder={PlaceholderImage}
                />
                {content?.getType() !== ContentType.TEMPLATE && <div className="duration">
                    <Text
                        textType={TextType.caption1}
                        fontFamilyVariant={FontFamilyVariant.light}
                        text={`${getContentDuration(content?.getDuration())} ${!isVideo ? translate(t, libraryMessages.read) : ""}`}
                        className="duration_text"
                    />
                </div>}
            </div>
            <div className="bottom_card_container">
                <div className="tag_container">
                    <div className="tag">
                        {tags?.map((tag) => {
                            return <span className="tag_name" key={tag}>
                                {tag}
                            </span>
                        })}
                    </div>
                    <Text
                        textType={TextType.caption1}
                        fontFamilyVariant={FontFamilyVariant.light}
                        text={DateHelper.getDateTime(uploadedDate as unknown as Date, DEFAULT_DATE_FORMAT)}
                        className="created_on"
                    />
                </div>
                <div className="description_container">
                    <Text
                        textType={TextType.caption1}
                        fontFamilyVariant={FontFamilyVariant.light}
                        text={title}
                        className="description"
                    />
                </div>
            </div>
        </Card>
    )
}

export default ContentCard;
